import { handleErrors } from "../utils/error-handler";
import apiClient from "./axios.config";

const productService = {
  getProductCategory: async () => {
    try {
      const response = await apiClient.get(`/website/category`);
      return response?.data?.data || [];
    } catch (error) {
      throw handleErrors(error); // Throwing the processed error
    }
  },

  getProductSubCategory: async (categoryId) => {
    try {
      const response = await apiClient.get(
        `/website/sub-category?categoryId=${categoryId}`
      );
      return response?.data?.data || [];
    } catch (error) {
      throw handleErrors(error); // Throwing the processed error
    }
  },
  getServiceDetails: async (id, subCategoryUrl) => {
    try {
      const response = await apiClient.post(`/website/sub-category-details`, {
        id,
      });
      return response?.data?.data || [];
    } catch (error) {
      throw handleErrors(error);
    }
  },
  getProducteDetails: async (id) => {
    try {
      const response = await apiClient.post(`/website/products`, {
        id,
      });
      return response?.data?.data || [];
    } catch (error) {
      throw handleErrors(error);
    }
  },
  submitEnquiry: async (payload) => {
    try {
      const response = await apiClient.post(
        `/website/product-enquiry`,
        payload
      );
      return response?.data;
    } catch (error) {
      throw handleErrors(error);
    }
  },
  submitDirectEnquiry: async (payload) => {
    try {
      const response = await apiClient.post(`/website/enquiry-form`, payload);
      return response?.data;
    } catch (error) {
      throw handleErrors(error);
    }
  },
  submitVendorEnquiry: async (payload) => {
    try {
      const response = await apiClient.post(`/website/vendor-enquiry`, payload);
      return response?.data;
    } catch (error) {
      throw handleErrors(error);
    }
  },
};

export default productService;
